<template>
  <div class="RelatedSection">
    <h3 class="mb-4 text-xs text-gray-900">
      Referenced in {{ items.length }}
      {{ section | pluralizeWord(items.length) }}
    </h3>
    <ul>
      <li v-for="item in items" :key="item._id" class="mb-2 flex items-center">
        <lm-icon class="mr-2" icon="notes" size="20" />
        <router-link
          class="text-xs text-gray-700"
          :to="{name: section, params: computedSlug(item.slug)}"
        >
          {{ item.title }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import LmIcon from '@/components/ui/LmIcon'

export default {
  name: 'RelatedSection',
  components: {LmIcon},
  props: {
    section: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    computedSlug(slug) {
      const s = {}
      s[this.section + 'Slug'] = slug
      return s
    }
  }
}
</script>
